<div class="container">
  <div class="row">
    <div class="col col-12" style="flex-basis: max-content; margin: auto; min-height: 120px;">
      <ngx-charts-bar-vertical [view]="view" [scheme]="colorScheme" [results]="daysToComplete" [gradient]="gradient"
        [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend" [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [view]="[144,120]">
        <ng-template #tooltipTemplate let-model="model">
          {{model.name}} days<br />
          {{model.value}} audit<span *ngIf="model.value != 1">s</span>
        </ng-template>
      </ngx-charts-bar-vertical>
    </div>
    <div class="col col-12 text-center">
      <span class="h1 font-weight-bold text-primary" style="font-size:2.0vw;">{{avDaysToComplete | number: '1.0-0'}}</span>
    </div>
    <div class="col col-12 text-center">
      <span class="text-primary">Average days to complete</span>
    </div>
  </div>
</div>
